module.exports = __webpack_public_path__ + "img/changshin.35293850.jpg";